
import React, { useState } from 'react';
import { ShieldCheck, HelpCircle, Info } from 'lucide-react';

export const HUD = ({ metrics, wealthMetrics, onOpenHelp }: any) => {
  const [activeHint, setActiveHint] = useState<string | null>(null);

  const toggleHint = (id: string) => {
    setActiveHint(activeHint === id ? null : id);
  };

  return (
    <header className="sticky top-0 z-[90] bg-white/80 backdrop-blur-xl border-b border-slate-100" onClick={() => setActiveHint(null)}>
      <div className="max-w-4xl mx-auto px-6 py-5 flex justify-between items-center">
        <div className="flex items-center gap-3">
           <div className="w-10 h-10 rounded-2xl overflow-hidden flex items-center justify-center shadow-lg shadow-emerald/20 bg-white">
             <img 
               src="https://lh3.googleusercontent.com/d/1V43bsQ1MSLTCV946PqQyzxJ8w55-MtJc" 
               alt="StackUp Logo" 
               className="w-full h-full object-cover"
               referrerPolicy="no-referrer"
             />
           </div>
           <div className="flex flex-col">
             <span className="font-extrabold text-xl tracking-tight text-navy leading-none">Stack<span className="text-emerald">Up</span></span>
             <span className="text-[10px] font-inter uppercase font-bold text-slate-400 tracking-wider">Modern Finance</span>
           </div>
        </div>

        <div className="flex items-center gap-4 sm:gap-6">
          <div className="flex flex-col items-end relative">
             <div className="flex items-center gap-1 mb-0.5">
               <button 
                 onClick={(e) => { e.stopPropagation(); toggleHint('net-worth'); }}
                 className="text-slate-300 hover:text-emerald transition-colors"
               >
                 <Info size={10} />
               </button>
               <div className="text-[10px] font-inter text-slate-400 uppercase font-bold tracking-wider">Net Worth</div>
             </div>
             <div className="flex items-center gap-1.5">
               <ShieldCheck size={14} className="text-emerald" />
               <div className="text-lg font-bold text-navy">
                 R{wealthMetrics?.nav?.toLocaleString() || '0'}
               </div>
             </div>
             {activeHint === 'net-worth' && (
               <div className="absolute top-full mt-2 right-0 w-48 bg-navy text-white text-[10px] p-3 rounded-xl shadow-2xl z-[100] animate-fade-in border border-white/10">
                 <div className="font-black mb-1 uppercase tracking-widest text-emerald">Net Worth</div>
                 Total value of what you own minus what you owe. The ultimate measure of wealth.
               </div>
             )}
          </div>

          <div className="h-8 w-px bg-slate-100 hidden sm:block"></div>

          <div className="hidden sm:flex flex-col items-end relative">
             <div className="flex items-center gap-1 mb-1">
               <button 
                 onClick={(e) => { e.stopPropagation(); toggleHint('efficiency'); }}
                 className="text-slate-300 hover:text-emerald transition-colors"
               >
                 <Info size={10} />
               </button>
               <div className="text-[10px] font-inter text-slate-400 uppercase font-bold tracking-wider">Efficiency</div>
             </div>
             <div className="flex items-center gap-3">
                <div className="w-20 h-2 bg-slate-100 rounded-full overflow-hidden">
                  <div className="h-full bg-emerald transition-all duration-1000" style={{ width: `${Math.min(100, Math.max(0, metrics.savingsRate))}%` }}></div>
                </div>
                <span className="text-sm font-bold text-emerald">{metrics.savingsRate}%</span>
             </div>
             {activeHint === 'efficiency' && (
               <div className="absolute top-full mt-2 right-0 w-48 bg-navy text-white text-[10px] p-3 rounded-xl shadow-2xl z-[100] animate-fade-in border border-white/10">
                 <div className="font-black mb-1 uppercase tracking-widest text-emerald">Efficiency</div>
                 Your Savings Rate. The percentage of income kept after expenses. (Surplus / Income).
               </div>
             )}
          </div>

          <button 
            onClick={onOpenHelp}
            className="p-2 text-slate-300 hover:text-emerald transition-colors focus:outline-none"
            aria-label="Financial Manual"
          >
            <HelpCircle size={22} />
          </button>
        </div>
      </div>
    </header>
  );
};
